import { PropsWithChildren, useEffect, useState } from "react";

export const WithCookieConsent = (props: PropsWithChildren) => {
  const [hasConsent, setHasConsent] = useState(false);

  useEffect(() => {
    if (!window) {
      return;
    }
    const checkConsent = () => {
      if (window.Cookiebot?.consent) {
        setHasConsent(window.Cookiebot.consent.statistics);
      }
    };

    checkConsent();

    window.addEventListener("CookiebotOnConsentReady", checkConsent);

    return () => {
      window.removeEventListener("CookiebotOnConsentReady", checkConsent);
    };
  }, []);

  if (!hasConsent) {
    return null;
  }

  return props.children;
};
